module.exports = __webpack_public_path__ + "media/hyper/fonts/unicons-31bc37652b168677337f252788fd4e0b.woff";